import React, { Component } from "react";
import axios from "axios";

import Button1Item from "./Button1Item";

export class Button1Banners extends Component {
    state = {
        extras: [],
        isLoaded: false,
    };
    
    componentDidMount() {
        axios
        .get("https://obrien365.com/ob-wp/wp-json/wp/v2/extras?slug=team-button")
        .then((res) =>
        this.setState({
            extras: res.data,
            isLoaded: true,
        })
        )
        .catch((err) => console.log(err));
    }

    
    
    render() {
    const { extras, isLoaded } = this.state;
    if (isLoaded) {
        return (
        <>
            
            {extras.map(extra => (
                //@ts-ignore
                <Button1Item key={extra.id} extra={extra} />
            ))}
            
        </>
        );
    }
    return <div className="loading"><h3>Loading...</h3></div>;
    }
}
export default Button1Banners;